export const environment = {
  production: false,
  APIUrl:  "https://portal.distone.com/musclefoodscuratedAPI",
  cookname: 'musclefoodscurated031325',
  storagetime:  ((60000 * 1 * 60) * 12),
  isheaderbanner:0,
  ga:'G-YG07B96CJY',
  istranslate:0,
  customerId: '', // Customer-specific identifier for custom styling
};